//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { type Theme } from '@mui/material/styles';

// Row styling for the mobile drawer's menu rows, shared so every section
// draws its rows the same way and a palette change lands everywhere at once.
export const drawerRowSx = (theme: Theme) => ({
  color: theme.palette.menuPanel.default.text,
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: theme.palette.menuPanel.hover.background,
    color: theme.palette.menuPanel.hover.text,
    '& .MuiListItemIcon-root': {
      color: theme.palette.menuPanel.hover.text
    }
  },
  '& .MuiListItemIcon-root': {
    color: theme.palette.menuPanel.default.text
  }
});
